'use client'

import { ButtonLink } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { Icon, Row } from '@repo/ui/components'

export const BalanceNavbar = () => {
  const { t } = useTranslate()
  return (
    <Row className='fixed bottom-0 left-0 w-full right-0 justify-between h-fit gap-md p-md bg-neutral-surface-light rounded-t-sm border-t  border-neutral-surface-dark shadow-sm'>
      <ButtonLink
        href='/wallet/withdraw/online-payment'
        width='full'
        size='md'
        className='w-1/2'
        startIcon={<Icon name='TriangleArrowUpLine' size='md' />}
        variant='transparent'
      >
        {t('walletPage_withdraw')}
      </ButtonLink>
      <ButtonLink
        href='/wallet/deposit'
        width='full'
        size='md'
        className='w-1/2'
        variant='fill'
        startIcon={<Icon name='PlusLine' size='md' />}
      >
        {t('walletPage_deposit')}
      </ButtonLink>
    </Row>
  )
}
